import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/pinkchecker.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = { class: "lrdiffbox" }

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import HzPlayer from './components/HzPlayer.vue'
import HandModal from './components/HandModal.vue'
import NumberSpinner from './components/NumberSpinner.vue'
import FreqPage from './pages/FreqPage.vue'
import { useFrequencyStore } from './store/frequency'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const useCenterFreq = ref(false)
const lrDelay = ref(0)

const lrGainDiffDb = ref(0)
watch(() => lrGainDiffDb.value, (v) => {
  if (v < -48) {
    lrGainDiffDb.value = -48
  } else if (v > 48) {
    lrGainDiffDb.value = 48
  }
})

const lGain = computed(() => {
  if (lrGainDiffDb.value <= 0) return 1
  else return Math.pow(10, -lrGainDiffDb.value / 20)
})

const rGain = computed(() => {
  if (lrGainDiffDb.value >= 0) return 1
  else return Math.pow(10, lrGainDiffDb.value / 20)
})

const playL = ref(false)
const playC = ref(false)
const playR = ref(false)
const freqStore = useFrequencyStore()
const showHandModal = ref(true)

const frequency = computed(() => {
  if (useCenterFreq.value) return 632.45553
  else return freqStore.frequency
})

function playLeftOnly (): void {
  playL.value = true
  playR.value = playC.value = false
}

function playROnly (): void {
  playR.value = true
  playL.value = playC.value = false
}

function playLRIndependent (): void {
  playL.value = playR.value = true
  playC.value = false
}

function playCenterOnly (): void {
  playC.value = true
  playL.value = playR.value = false
}

function swapMode (): void {
  // L ↔ R
  // L+R ↔ L+R (Ind.)
  if (playL.value) {
    if (playR.value) {
      // L+R (Ind.) -> C
      playL.value = playR.value = false
      playC.value = true
    } else {
      // L -> R
      playR.value = true
      playL.value = false
    }
  } else {
    if (playR.value) {
      // R -> L
      playL.value = true
      playR.value = false
    } else if (playC.value) {
      // C -> L+R (Ind.)
      playL.value = true
      playR.value = true
      playC.value = false
    } else {
      // Do nothing. (Stopped)
    }
  }
}

onMounted(() => {
  window.addEventListener('keydown', onKeyDown)
  window.addEventListener('keyup', onKeyUp)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeyDown)
  window.removeEventListener('keyup', onKeyUp)
})

// EQ

function booleanToGainMultiplier (b: boolean): number {
  if (b) return 1
  else return 0
}

function onKeyDown (event: KeyboardEvent): void {
  if (event.repeat) return
  switch (event.key.toLowerCase()) {
    case 'e':
      swapMode()
      break

    case 'c':
      useCenterFreq.value = true
      break
  }
}

function onKeyUp (event: KeyboardEvent): void {
  if (event.key.toLowerCase() === 'c') {
    useCenterFreq.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showHandModal.value)
      ? (_openBlock(), _createBlock(HandModal, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showHandModal.value = false))
        }))
      : _createCommentVNode("", true),
    (!showHandModal.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(HzPlayer, {
            frequency: frequency.value,
            Q: _unref(freqStore).Q,
            gain: booleanToGainMultiplier(playL.value) * 0.25 * _unref(freqStore).gain,
            panning: -1,
            "lr-delay": lrDelay.value,
            "l-gain": lGain.value,
            "r-gain": rGain.value
          }, null, 8, ["frequency", "Q", "gain", "lr-delay", "l-gain", "r-gain"]),
          _createVNode(HzPlayer, {
            frequency: frequency.value,
            Q: _unref(freqStore).Q,
            gain: booleanToGainMultiplier(playC.value) * 0.35 * _unref(freqStore).gain,
            panning: 0,
            "lr-delay": lrDelay.value,
            "l-gain": lGain.value,
            "r-gain": rGain.value
          }, null, 8, ["frequency", "Q", "gain", "lr-delay", "l-gain", "r-gain"]),
          _createVNode(HzPlayer, {
            frequency: frequency.value,
            Q: _unref(freqStore).Q,
            gain: booleanToGainMultiplier(playR.value) * 0.25 * _unref(freqStore).gain,
            panning: 1,
            "lr-delay": lrDelay.value,
            "l-gain": lGain.value,
            "r-gain": rGain.value
          }, null, 8, ["frequency", "Q", "gain", "lr-delay", "l-gain", "r-gain"])
        ], 64))
      : _createCommentVNode("", true),
    _cache[15] || (_cache[15] = _createElementVNode("h1", null, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "logo"
      }),
      _createTextVNode(" pinkchecker ")
    ], -1)),
    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "author" }, "by trgk (phu54321@naver.com)", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _cache[9] || (_cache[9] = _createTextVNode(" L to R Delay ")),
        _createVNode(NumberSpinner, {
          "decimal-precision": 5,
          step: 0.00001,
          modelValue: lrDelay.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lrDelay).value = $event))
        }, null, 8, ["modelValue"]),
        _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("span", { title: "Useful for frequency-matching different headphones" }, "LR decibel offset", -1)),
        _cache[12] || (_cache[12] = _createTextVNode()),
        _createVNode(NumberSpinner, {
          "decimal-precision": 5,
          step: 0.1,
          modelValue: lrGainDiffDb.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lrGainDiffDb).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("button", {
          class: _normalizeClass({on: playL.value && !playR.value}),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (playLeftOnly()))
        }, "Play L", 2),
        _createElementVNode("button", {
          class: _normalizeClass({on: playC.value}),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (playCenterOnly()))
        }, "L+R", 2),
        _createElementVNode("button", {
          class: _normalizeClass({on: playL.value && playR.value}),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (playLRIndependent()))
        }, "L+R (Ind.)", 2),
        _createElementVNode("button", {
          class: _normalizeClass({on: playR.value && !playL.value}),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (playROnly()))
        }, "Play R", 2),
        _cache[13] || (_cache[13] = _createTextVNode("     ")),
        _createElementVNode("button", {
          class: _normalizeClass({on: !(playL.value || playR.value || playC.value)}),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (playL.value = playR.value = playC.value = false))
        }, "Stop", 2),
        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("button", {
          class: _normalizeClass({on: useCenterFreq.value}),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (useCenterFreq.value = !useCenterFreq.value))
        }, "Compare with center (C)", 2),
        _createElementVNode("button", { onClick: swapMode }, "Swap speaker (E)")
      ])
    ]),
    _createVNode(FreqPage)
  ]))
}
}

})